(function ($) {
    $.fn.inlineStyle = function (prop) {
        var styles = this.attr("style"),
            value;
        styles && styles.split(";").forEach(function (e) {
            var style = e.split(":");
            if ($.trim(style[0]) === prop) {
                value = style[1];
            }
        });
        return $.trim(value);
    };
}(jQuery));



// WEBPACK FOOTER //
// ./app/directives/nginlinestyle.js